







































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { SUBMODULES_PATHS } from '../../../store';
import { SEARCH_GETTERS_KEYS } from '../../../store/search/search.const';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';
import ClearSelectedFiltersByGroup from './clear-selected-filters-by-group.vue';
import CloseFacetsGroup from './close-facets-group.vue';
import Facets from './facets';
import SelectedFiltersByGroup from './group-selected-filters.vue';

@Component({
  components: { Facets, CloseFacetsGroup, ClearSelectedFiltersByGroup, SelectedFiltersByGroup },
  computed: {
    ...mapGetters(SUBMODULES_PATHS.search, {
      hasResults: SEARCH_GETTERS_KEYS.hasResults
    })
  }
})
export default class FacetsGroup extends Mixins(FacetsGroupMixin) {

}
